import * as React from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { useEffect, useLayoutEffect, useState } from "react";
import Grid from "./Layouts/Grid";
import Scrollable from "./Layouts/Scrollable";
import Carousel from "./Layouts/Carousel";
import FlexGrid from "./Layouts/FlexGrid";
import "./Multicolumn.scss";
import { handleize } from "frontend/js/helpers";




const layouts = {
  'grid': Grid,
  'none': Grid,
  'flex_grid': FlexGrid,
  'scrollable': Carousel,
  'carousel': Carousel,
}

export const Multicolumn = ({
  settings,
  columns,
  headerText,
  subtext,
  tagline,
  columns_count,
}) => {

  let isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const [isLoaded, setIsLoaded] = useState(false);
  const [currentHash, setCurrentHash] = useState('');
  

  const layout = isMobile ? settings?.section.layout_mobile : settings?.section.layout;
  const LayoutComponent = layouts[layout] || Grid;
  let filteredColumns = columns;
  if (isMobile) {
    filteredColumns = columns.filter((column) => column.settings.render_type === 'all');
  }
  
  const customId = handleize(settings?.section?.custom_id ||  headerText);
  
  useEffect(() => {
    if (isMobile !== undefined) {
      setIsLoaded(true);
    }
  }, [isMobile]);
  
  useEffect(() => {
    setCurrentHash(window.location.hash);
    
    const handleHashChange = () => {
      setCurrentHash(window.location.hash);
    };
    
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);
  
  useEffect(() => {
    function scrollToAnchor() {
      if (currentHash) {
        const anchor = currentHash.replace('#', '');
        setTimeout(() => {
          const el = document.getElementById(anchor);
          if (el) {
  
            const header = document.querySelector('.header-container');
            const headerHeight = header ? header.getBoundingClientRect().height : 0;
            
            const elementPosition = el.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
              top: elementPosition - headerHeight,
              behavior: 'smooth'
            });
          }
        }, 100);
      }
    }

    scrollToAnchor();
  }, [currentHash]);
  
  if (!isLoaded) {
    return null;
  }

  if (settings.section.render_type !== "all") {
    if (isMobile && settings.section.render_type !== "mobile-only") return null;
    if (!isMobile && settings.section.render_type !== "desktop-only") return null;
  }

  const isNullOrEmpty = (value) => {
    if (Array.isArray(value)) {
      return value.length === 0 || value.some(item => !item?.title?.trim());
    }
    return value === null || value === undefined || (typeof value === 'string' && !value.trim());
  };

  if (settings.section.render_if_content) {
    const variablesToCheck = [
      ...settings.blocks.map(block => block.settings.title),
      ...settings.blocks.map(block => block.settings.content),
    ];

    const hasEmptyOrNull = variablesToCheck.some(isNullOrEmpty);

    if (hasEmptyOrNull) {
      return null;
    }
  }

  return (
    <>
      <LayoutComponent
          settings={settings}
           columns={filteredColumns}
           headerText={headerText}
           subtext={subtext}
           tagline={tagline}
           columns_count={columns_count}
           customId={customId}
      />
    </>
  );
};

export default Multicolumn;
